const pairs = `
검색:|Search:
제품명을 검색하세요|Search products
솔티드|SALTED
뉴스|News
기사를 불러오는 중 오류가 발생했습니다.|Unable to load articles.
솔티드 소식|SALTED News
솔티드의 최신 뉴스와 기술 동향을 전합니다.|The latest news and technology updates from SALTED.
최신 기사|Latest Articles
물리 데이터로 구축할|Ready to build
준비가 되셨나요?|with physical data?
PhysioLink SDK를 사용하여|Join innovators using PhysioLink SDK
인간의 움직임을 실행 가능한 인사이트로 전환하는|to translate human movement
선도 혁신가들과 함께하세요|into actionable insights.
데모 액세스 요청|Request Demo Access
영업팀 문의|Contact Sales
빠른 시작|Quick Start
데모 엑세스로|Get started
빠르게 시작|with demo access
전문 지원|Expert Support
전담 기술팀의|Ongoing support from
지속적인 지원|our dedicated technical team
검증된 기술|Validated Technology
90,000건 이상의|Based on over 90,000
실사용 데이터 기반|real-world records
압력 매핑|Pressure Mapping
발당 6개 고정밀 센서|Six high-precision sensors per foot
힘 측정: 0-1000 N/cm²|Force measurement: 0–1000 N/cm²
백분율 분포: 0-100%|Percentage distribution: 0–100%
실시간 압력 중심 추적|Real-time center-of-pressure tracking
사분면 분석 (좌/우, 전/후)|Quadrant analysis (left/right, front/back)
보행 분석|Gait Analysis
발별 지면 접촉 시간|Ground contact time per foot
케이던스 (분당 걸음 수)|Cadence (steps per minute)
착지 패턴 분류|Foot strike classification
보폭 및 페이스 계산|Stride length and pace calculation
좌우 대칭성 분석|Left–right symmetry analysis
실시간 스트리밍|Real-Time Streaming
센서에서 앱까지 50ms 미만 지연|Less than 50 ms latency from sensor to app
Bluetooth LE 5.0 연결|Bluetooth LE 5.0 connectivity
연결 끊김 시 자동 재연결|Automatic reconnection
백그라운드 서비스 지원|Background service support
양발 동기화|Bilateral synchronization
IMU 데이터 융합|IMU Data Fusion
3축 가속도계 (±16G)|3-axis accelerometer (±16G)
3축 자이로스코프 (±2000°/s)|3-axis gyroscope (±2000°/s)
설정 가능한 샘플링 (33-100Hz)|Configurable sampling (33–100 Hz)
내장 메모리 녹화|Onboard memory recording
데이터 내보내기|Data Export
연구용 CSV 내보내기|CSV export for research
웹 통합용 JSON 형식|JSON format for web integration
구간별 리포트 (100m/1km/1마일)|Segment reports (100 m / 1 km / 1 mile)
REST API 호환|REST API compatibility
의료기기 등급|Medical Device Grade
1등급 의료기기 (식약처)|Class I medical device (MFDS)
임상 환경 검증 완료|Validated in clinical settings
10년 이상 센서 기술 개발|Over 10 years of sensor development
90,000건 이상 실사용 검증|Over 90,000 real-world records
ISO 13485 제조 표준|ISO 13485 manufacturing standards
핵심 기능|Core Capabilities
모든 사용 사례를 위한 포괄적인 생체역학 데이터|Comprehensive biomechanical data across use cases
50ms 미만 지연|Less than 50 ms latency
최대 100Hz 샘플링|Up to 100 Hz sampling
BLE 5.0 연결|BLE 5.0 connectivity
인간의 움직임을|Turn human movement
실행 가능한 데이터로|into actionable data
PhysioLink SDK로 차세대 헬스케어,|Build next-generation healthcare,
로보틱스, 게이밍 애플리케이션을 구축하세요|robotics and gaming applications with PhysioLink SDK
90,000건 이상의 검증된 실사용 데이터 기반|Based on over 90,000 validated real-world records
의료기기 인증 완료 · iOS/Android 네이티브 지원|Medical device certification · Native iOS / Android support
데모 신청하기|Request a Demo
기술 개요 보기|Explore the Technology
검증된 데이터|Validated Data
초저지연|Ultra-Low Latency
6개|6
압력 센서|Pressure Sensors
6축|6-axis
IMU 데이터|IMU Data
iOS & Android 네이티브|Native iOS & Android
iOS 13+ 및 Android 8+ 완전 지원. Swift, Kotlin 등 주요 언어 호환|Support for iOS 13+ and Android 8+, compatible with Swift, Kotlin and other languages
초저지연(50ms 이하) 데이터 전송. Bluetooth LE 5.0 자동 재연결|Low-latency data transfer (50 ms or less) and automatic Bluetooth LE 5.0 reconnection
고정밀 센서|High-Precision Sensors
발당 6개 압력 센서로 0-1000 N/cm² 범위 정밀 측정|Six pressure sensors per foot measuring 0–1000 N/cm²
6축 IMU 융합|6-Axis IMU Fusion
가속도계, 자이로스코프 센서로 정밀한 모션 트래킹 (최대 100Hz)|Motion tracking with accelerometer and gyroscope sensors (up to 100 Hz)
의료기기 인증|Medical Device Certification
식약처 1등급 의료기기 인증 및 임상 환경 검증 완료|MFDS Class I medical device registration and clinical validation
AI 최적화|AI-Optimized
머신러닝 및 AI 알고리즘 개발에 최적화된 데이터 구조|Data structures optimized for machine learning and AI development
엔터프라이즈급|Enterprise-Grade
움직임 데이터 플랫폼|Movement Data Platform
의료기기 등급 스마트 인솔에서|Comprehensive access
실시간 생체역학 데이터에 대한|to real-time biomechanical data
포괄적인 액세스를 제공합니다.|from medical-grade smart insoles.
검증된 데이터,|Validated data,
신뢰할 수 있는 기술|reliable technology
90,000건 이상의 실사용 데이터|Over 90,000 Real-World Records
의료 및 스포츠 현장에서 수집된 검증된 데이터 기반|Validated data collected in healthcare and sports settings
10년 이상의 센서 기술 개발|Over 10 Years of Sensor Development
지속적인 연구개발로 검증된 하드웨어 및 소프트웨어|Hardware and software developed through continued research
의료 및 산업 확장성|Healthcare & Industry Scalability
다양한 산업 분야에 적용 가능한 유연한 플랫폼|A flexible platform for multiple industries
개발자|Developer
연구 및 개발용|For research and development
무료|Free
스마트 인솔 연구용 세트 구매 시|With purchase of a research smart insole set
SDK 전체 기능 접근 (3개월 제공)|Full SDK access for 3 months
기술 문서 및 샘플 코드|Documentation and sample code
커뮤니티 지원|Community support
기술 지원|Technical support
시작하기|Get Started
프로페셔널|Professional
상업용 애플리케이션|For commercial applications
맞춤 가격|Custom Pricing
비즈니스 규모에 따라|Based on your business scale
무제한 API 호출|Unlimited API calls
우선 기술 지원|Priority technical support
고급 분석 및 리포팅|Advanced analytics and reporting
맞춤형 통합 지원|Custom integration support
SLA 보장|SLA guarantees
전담 계정 매니저|Dedicated account manager
엔터프라이즈|Enterprise
대규모 조직용|For large organizations
맞춤형 계약|Custom Agreement
조직 요구사항에 따라|Based on organizational requirements
온프레미스 배포 옵션|On-premises deployment options
전용 인프라 구성|Dedicated infrastructure
24/7 프리미엄 지원|24/7 premium support
맞춤형 기능 개발|Custom feature development
보안 감사 및 컴플라이언스|Security audits and compliance
전담 엔지니어링 팀|Dedicated engineering team
상담 요청|Request a Consultation
가격 플랜|Pricing Plans
개발 및 배포 요구사항에 맞는 플랜을 선택하세요|Choose a plan for your development and deployment needs
추천|Recommended
가격 정책 안내|Pricing Information
프로페셔널 티어에는 SDK 라이선스 및 기술 지원이 포함됩니다. 하드웨어 가격은 요청 시 제공되며 100개 이상부터 볼륨 할인이 적용됩니다.&nbsp; 엔터프라이즈 고객을 위한 맞춤형 계약 및 특별 조건은 영업팀과 상담하시기 바랍니다.|The Professional tier includes SDK licensing and technical support. Hardware pricing is available on request, with volume discounts for 100 or more units. Contact Sales for Enterprise agreements and terms.
더 자세한 정보가 필요하신가요?|Need More Information?
영업팀 문의하기|Contact Sales
데이터 출력|Data Output
발당 6개|6 per foot
측정 범위|Measurement Range
백분율|Percentage
샘플링|Sampling
6축 (가속도계/자이로스코프)|6-axis (accelerometer / gyroscope)
플랫폼 지원|Platform Support
13.0 이상|13.0 or later
호환|Compatible
연결성|Connectivity
프로토콜|Protocol
범위|Range
최대 10미터|Up to 10 meters
지연|Latency
50ms 미만|Less than 50 ms
자동 재연결|Auto Reconnect
지원|Supported
백그라운드|Background
양발|Both Feet
동시 연결|Simultaneous connection
하드웨어|Hardware
배터리|Battery
리튬폴리머|Lithium polymer
수명|Battery Life
연속 8-10시간|8–10 hours continuously
메모리|Memory
4MB 플래시|4 MB flash
녹화|Recording
최대 2시간|Up to 2 hours
방수|Water Resistance
IP54 등급|IP54 rating
무게|Weight
인솔당 300g 미만|Less than 300 g per insole
데이터 관리|Data Management
저장소|Storage
Core Data (로컬)|Core Data (local)
클라우드|Cloud
동기화 준비|Sync-ready
내보내기|Export
구간|Segments
100m/1km/1마일|100 m / 1 km / 1 mile
보존|Retention
설정 가능|Configurable
REST 호환|REST-compatible
SDK 기능|SDK Features
사전 구축 컴포넌트|Prebuilt Components
관리|Management
기기 화면|Device screens
콜백|Callbacks
실시간 데이터|Real-time data
운동|Exercise
녹화 로직|Recording logic
진동|Haptics
28가지 패턴|28 patterns
복구|Recovery
자동 세션|Automatic session
기술 사양|Technical Specifications
개발자를 위한 포괄적인 기술 세부 정보|Technical details for developers
안정성과 확장성|Reliability & Scalability
PhysioLink SDK는 의료 환경에서 검증된 안정성과|PhysioLink SDK provides reliability validated in healthcare
대규모 배포를 위한 확장성을 제공합니다.|and scalability for large deployments.
식약처 1등급 인증|MFDS Class I Registration
실시간 처리|Real-Time Processing
글로벌 배포|Global Deployment
다국어 및 다지역 지원|Multilingual and multi-region support
로보틱스 & 외골격|Robotics & Exoskeletons
지능형 움직임 시스템 구현|Building intelligent movement systems
실시간 보행 데이터는 웨어러블 로보틱스를 위한 반응형 제어와 적응형 보조를 가능하게 합니다.|Real-time gait data enables responsive control and adaptive assistance in wearable robotics.
실시간 보행 단계 감지를 통한 외골격 제어 시스템|Exoskeleton control through real-time gait phase detection
환자 진행 상황 모니터링을 위한 재활 로보틱스|Rehabilitation robotics for monitoring patient progress
작업자 피로도 감지를 위한 산업용 외골격|Industrial exoskeletons for detecting worker fatigue
동적 토크 조정 및 낙상 방지|Dynamic torque adjustment and fall prevention
실시간 제어 루프를 위한 50ms 미만 지연|Less than 50 ms latency for real-time control loops
예측 제어를 위한 보행 단계 예측|Gait phase prediction for predictive control
적응형 보조 수준을 위한 힘 피드백|Force feedback for adaptive assistance
ROS(Robot Operating System)와 통합|ROS integration
외골격 제조사, 재활 로보틱스 기업, 산업 안전 장비 제공업체|Exoskeleton manufacturers, rehabilitation robotics and industrial safety providers
헬스케어 & 디지털 치료제|Healthcare & Digital Therapeutics
더 나은 결과를 위한 움직임 정량화|Quantifying movement for better outcomes
객관적인 생체역학 데이터는 재활과 만성 질환 관리를 데이터 기반 치료로 전환합니다.|Objective biomechanical data supports data-driven rehabilitation and chronic disease management.
신경학적 재활 (뇌졸중, 파킨슨병, 다발성 경화증)|Neurological rehabilitation (stroke, Parkinson's, multiple sclerosis)
근골격계 치료 및 수술 후 회복|Musculoskeletal treatment and postoperative recovery
노인 인구의 낙상 위험 평가|Fall risk assessment for older adults
원격 환자 모니터링 및 원격의료 통합|Remote patient monitoring and telehealth integration
의료기기 인증 (1등급)|Class I medical device registration
90,000건 이상 데이터로 임상 검증|Clinical validation with over 90,000 records
HIPAA 준수 데이터 처리 준비|HIPAA-ready data processing
EMR/EHR 시스템과 통합|EMR / EHR integration
디지털 치료제 기업, 원격의료 플랫폼, 의료기기 제조사, 병원 시스템|Digital therapeutics, telehealth platforms, medical device manufacturers and hospitals
게임 & 메타버스|Gaming & Metaverse
가상 세계에 실제와 같은 움직임 구현|Real-world movement in virtual worlds
실제 인간 움직임 데이터는 전례 없는 리얼리즘과 반응성으로 몰입형 경험을 창출합니다.|Human movement data creates immersive experiences with realism and responsiveness.
아바타 이동 제어를 통한 VR/AR 게임|VR / AR gaming with avatar movement control
메타버스 애플리케이션 및 디지털 트윈 생성|Metaverse applications and digital twins
비용 효율적인 모션 캡처 대안|Cost-effective motion capture alternatives
게임 분석 및 플레이어 피로도 감지|Gameplay analytics and player fatigue detection
발 움직임을 통한 실시간 위치 추적|Real-time tracking through foot movement
자연스러운 걷기/달리기 역학|Natural walking and running mechanics
점프 및 착지 감지|Jump and landing detection
Unity/Unreal Engine 플러그인 지원|Unity / Unreal Engine plugin support
VR/AR 게임 스튜디오, 메타버스 플랫폼 개발사, 모션 캡처 스튜디오|VR / AR studios, metaverse developers and motion capture studios
피트니스 & 스포츠|Fitness & Sports
모든 선수의 잠재력 최적화|Supporting every athlete's potential
정밀한 생체역학적 인사이트는 프로와 소비자 수준에서 개인화된 트레이닝과 부상 예방을 가능하게 합니다.|Biomechanical insights support personalized training and injury prevention for professionals and consumers.
전문 스포츠 트레이닝 및 기술 최적화|Professional sports training and technique optimization
실시간 코칭 피드백을 제공하는 소비자 피트니스 앱|Consumer fitness apps with real-time coaching
스마트 짐 장비 통합|Smart gym equipment integration
과사용 패턴 감지를 통한 부상 예방|Injury prevention through overuse pattern detection
러너를 위한 케이던스 및 페이스 정확도|Cadence and pace accuracy for runners
착지 충격 정량화|Quantifying landing impact
좌우 균형 분석|Left–right balance analysis
역사적 퍼포먼스 추세|Historical performance trends
피트니스 앱 개발사, 스마트 짐 장비 제조사, 스포츠 퍼포먼스 센터|Fitness app developers, smart gym manufacturers and sports performance centers
보험 & 헬스테크|Insurance & Healthtech
데이터 기반 위험 평가|Data-driven risk assessment
객관적인 이동성 데이터는 혁신적인 보험 상품과 건강 기반 금융 서비스를 가능하게 합니다.|Objective mobility data supports innovative insurance and health-related financial services.
생명 및 건강 보험 위험 점수|Life and health insurance risk scoring
웰니스 프로그램 및 활동 인센티브|Wellness programs and activity incentives
장기요양 보험 평가|Long-term care insurance assessment
활동 연계 기여금이 있는 건강저축계좌|Health savings accounts with activity-linked contributions
객관적이고 사기 방지 데이터|Objective, fraud-resistant data
종단적 건강 추적|Longitudinal health tracking
프라이버시 보호 집계|Privacy-preserving aggregation
규제 준수 준비 (HIPAA, GDPR)|Compliance readiness (HIPAA, GDPR)
보험사, 헬스테크 플랫폼, 직원 복지 제공업체, 웰니스 프로그램 운영사|Insurers, healthtech platforms, employee benefits providers and wellness operators
연구 & 학계|Research & Academia
과학적 발견 가속화|Accelerating scientific discovery
검증된 연구 등급 데이터는 생체역학, 신경과학 및 인간 퍼포먼스 분야의 획기적인 연구를 지원합니다.|Validated research-grade data supports biomechanics, neuroscience and human performance research.
생체역학 및 보행 분석 연구|Biomechanics and gait analysis research
객관적 결과 측정을 통한 임상시험|Clinical trials with objective outcome measures
뇌-움직임 관계에 대한 신경과학 연구|Neuroscience research into brain–movement relationships
스포츠 과학 및 트레이닝 방법론 검증|Sports science and training methodology validation
맞춤 분석을 위한 원시 데이터 접근|Raw data access for custom analysis
고주파수 샘플링 (최대 100Hz)|High-frequency sampling (up to 100 Hz)
외부 시스템과 동기화|Synchronization with external systems
MATLAB, Python, R 통합|MATLAB, Python and R integration
대학교, 연구 병원, 정부 연구 기관, 스포츠 과학 센터, 제약회사|Universities, research hospitals, government research institutes, sports science centers and pharmaceutical companies
산업별 활용 사례|Industry Use Cases
다양한 산업 분야에서 혁신을 주도하는 맞춤형 솔루션|Tailored solutions across industries
핵심 응용 분야|Key Applications
기술적 이점|Technical Benefits
타겟 파트너:|Target Partners:
iOS/Android 네이티브 지원 · 움직임 데이터 연동|Native iOS / Android support · Movement data integration
데이터 연동|Data Integration
센서 데이터 수집과 애플리케이션 연동을 위한 개발 도구|Development tools for sensor data collection and application integration
스마트 인솔에서 수집한|Access movement data
움직임 데이터를|collected by smart insoles
애플리케이션에 연결합니다.|and connect it to your application.
움직임 데이터,|Movement data,
누적 집계 수치이며, 환자 수나 임상적 유효성 검증 건수를 의미하지 않습니다.|An accumulated record total, not a patient count or evidence of clinical efficacy.
다양한 산업과의 연결|Connecting Across Industries
개발 및 연동|Development & Integration
iOS 및 Android 연동|iOS and Android integration
센서 데이터 수집 및 전송|Sensor data collection and transfer
CSV 및 JSON 데이터 내보내기|CSV and JSON data export
애플리케이션 개발을 위한 움직임 데이터 수집 및 연동|Movement data collection and integration for application development
PhysioLink SDK는 센서 데이터의 수집과|PhysioLink SDK supports sensor data collection
애플리케이션 연동을 지원합니다.|and application integration.
센서와 애플리케이션 연결|Connecting sensors and applications
센서에서 앱으로 데이터 전송|Sensor-to-app data transfer
연결 환경에 따라 상이|Varies with the connection environment
연결 환경별 확인 필요|Confirm for your connection environment
Bluetooth LE 기반 데이터 전송 및 자동 재연결|Bluetooth LE data transfer and automatic reconnection
발당 6개 압력 센서의 데이터를 수집|Data collection from six pressure sensors per foot
압력 센서 데이터 수집|Pressure sensor data collection
센서 데이터를 활용하는 제어 시스템 연동 검토|Explore sensor data integration with control systems
로봇 시스템의 움직임 데이터 기록|Movement data recording for robotic systems
산업용 외골격의 센서 데이터 연동|Sensor data integration for industrial exoskeletons
움직임 패턴 시각화|Movement pattern visualization
헬스케어 데이터 연동|Healthcare Data Integration
움직임 데이터를 연결하는 개발 도구|Development tools for connecting movement data
센서에서 수집한 움직임 데이터를 애플리케이션에 연동하는 개발 도구를 제공합니다.|Development tools connect sensor-based movement data to applications.
움직임 데이터 수집 화면 구성|Movement data collection interfaces
압력 분포 및 좌우 균형 시각화|Pressure distribution and left–right balance visualization
측정 세션 기록 및 비교 화면 구성|Measurement session recording and comparison interfaces
외부 애플리케이션과 데이터 연동 검토|Explore data integration with external applications
의료정보 시스템 연동은 별도 검토 필요|Health information system integration requires a separate review
헬스케어 서비스 및 데이터 연동 개발팀|Healthcare service and data integration development teams
움직임 데이터를 활용해 트레이닝 기록과 피드백 화면을 구성할 수 있습니다.|Movement data can be used to build training records and feedback interfaces.
활동별 움직임 패턴 기록|Movement pattern recording by activity
개인정보 처리 및 규제 요건은 도입 시 별도 검토|Privacy and regulatory requirements need a separate implementation review
움직임 데이터의 수집과 내보내기를 통해 연구용 분석 환경 구성을 지원합니다.|Movement data collection and export support research analysis workflows.
연구 프로토콜에 따른 움직임 데이터 수집|Movement data collection under a research protocol
산업별 연동 아이디어|Industry Integration Ideas
아래 항목은 개발 방향의 예시이며, 실제 도입 사례나 의료 사용목적을 의미하지 않습니다.|The following are development ideas, not deployed case studies or medical intended uses.
연동 검토 항목|Integration Considerations
SDK는 데이터 수집·연동을 위한 개발 도구입니다. 특정 의료기기의 인허가가 SDK 전체에 적용되는 것은 아니며, 의료 목적 사용은 해당 제품의 인허가 범위와 별도 검토가 필요합니다.|The SDK is a development tool for data collection and integration. A specific device’s regulatory authorization does not extend to the entire SDK. Medical use requires a separate review of the applicable product’s authorized scope.
집계 수치는 환자 수나 임상적 유효성 검증 건수가 아닙니다.|The record total is not a patient count or evidence of clinical efficacy.
연결 기기별 확인 필요|Confirm for the connected device
데이터 기반 기술|Data-Based Technology
연구개발을 통해 구축한 하드웨어 및 소프트웨어|Hardware and software built through research and development
활동 데이터 집계|Activity data aggregation
Bluetooth LE 데이터 전송|Bluetooth LE data transfer
`;
export const sdkTranslations: Record<string,string> = Object.fromEntries(pairs.trim().split('\n').map(row=>{const split=row.indexOf('|');return [row.slice(0,split),row.slice(split+1)]}));
